// Single source of truth for the active tax year.
// - consultant_assignments.tax_year is INTEGER → use TAX_YEAR directly.
// - parcel_values.tax_year is TEXT ('2026') → use String(TAX_YEAR) at the query site.
export const TAX_YEAR = 2026;
